import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Loader, LoaderContainer } from '../../Loader';
import './SecondaryNav.css';

const SecondaryNav = (props) => {

  if (props.loading) {
    return (
      <Row>
        <Col sm={12} className="visible-sm">
          <LoaderContainer>
            <Loader sizes={[100, 30]} spacer={40} />
          </LoaderContainer>
        </Col>
        <Col sm={12} className="visible-md">
          <LoaderContainer>
            <Loader sizes={[100, 40]} spacer={40} />
          </LoaderContainer>
        </Col>
        <Col sm={12} className="visible-lg">
          <LoaderContainer>
            <Loader align="left" sizes={[70, 50]} spacer={60} />
          </LoaderContainer>
        </Col>
      </Row>
    );
  }
  else {

    if (props.project.deliverables.length > 1 ) {
      return (
        <Row className="visible-sm visible-md visible-lg">
          <Col md={12}>
            <div className="SecondaryNav__ctn">
              {props.project.deliverables.map(
                (deliverable, index) => {
                  let activeClass = (props.activeTabIndex === index) ? 'SecondaryNav__tab--active' : '';
                  return (<div className={`SecondaryNav__tab ${activeClass}`} onClick={(event) => props.handleDeliverableToggle(index, event)} key={index}>{deliverable.label}</div>)
                }
              )
              }
            </div>
          </Col>
        </Row>) 
    }
    else {
      return (<div className="jp-hr"></div>)
    }

  }
}

export default SecondaryNav;


// WEBPACK FOOTER //
// ./src/components/Project/SecondaryNav/SecondaryNav.js